import { Variant } from 'types/entity/product';

type PrimaryKey = string | number | boolean | Array<string | number | boolean>;
interface ProductAttributeKeys {
  primaryKeys: PrimaryKey;
  secondaryKeys?: PrimaryKey;
  tertiaryKeys?: PrimaryKey;
}

const productTypeAttributeMap: Record<string, ProductAttributeKeys> = {
  Acrylic_Wall_Decor: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Framed_Prints_Wall_Decor: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: ['frame_color_wa_v1', 'frame_color_wa'],
    tertiaryKeys: ['mat_included_wa_v1', 'mat_included_wa'],
  },
  Canvas_Prints_Wall_Decor: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Metal_Wall_Decor: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Drinkware_PG: {
    primaryKeys: ['size_dd_v1', 'size_dd'],
    secondaryKeys: ['color_dd_v1', 'color_dd'],
    tertiaryKeys: '',
  },
  Desktop_PG: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Blankets_PG: {
    primaryKeys: ['size_textiles_v1', 'size_textiles'],
    secondaryKeys: ['material_textiles_v1', 'material_textiles'],
    tertiaryKeys: '',
  },
  Ornaments_PG: {
    primaryKeys: ['product_shape_ornaments_v1', 'product_shape_ornaments'],
    secondaryKeys: ['material_ornaments_v1', 'material_ornaments'],
    tertiaryKeys: '',
  },
  Google_Photo_Books: {
    primaryKeys: ['cover_type_pb_v1', 'cover_type_pb'],
    secondaryKeys: ['book_size_pb_v1', 'book_size_pb'],
    tertiaryKeys: '',
  },
  Hard_Cover: {
    primaryKeys: ['cover_type_pb_v1', 'cover_type_pb'],
    secondaryKeys: ['book_size_pb_v1', 'book_size_pb'],
    tertiaryKeys: '',
  },
  Soft_Cover: {
    primaryKeys: ['cover_type_pb_v1', 'cover_type_pb'],
    secondaryKeys: ['book_size_pb_v1', 'book_size_pb'],
    tertiaryKeys: '',
  },
  Layflat_Hardcover: {
    primaryKeys: ['cover_type_pb_v1', 'cover_type_pb'],
    secondaryKeys: ['book_size_pb_v1', 'book_size_pb'],
    tertiaryKeys: '',
  },
  OH_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Baby_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Occasions: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Graduation_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Thank_You_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Invitations: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Design_Your_Own_Card: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Birthday_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Wedding_Cards: {
    primaryKeys: ['trim_cards_v1', 'trim_cards'],
    secondaryKeys: ['pack_size_cards_v1', 'pack_size_cards'],
    tertiaryKeys: '',
  },
  Square_Prints: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Press_Prints: {
    primaryKeys: ['surface_pp_v1', 'surface_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Standard_Prints: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Retro_Prints: {
    primaryKeys: ['box_included_pp_v1', 'box_included_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Poster_Prints: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Collage_Prints: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  Desktop_Calendars: {
    primaryKeys: ['has_stand_calendar_v1', 'has_stand_calendar'],
    secondaryKeys: ['starting_month_v1', 'starting_month'],
    tertiaryKeys: ['starting_year_v1', 'starting_year'],
  },
  '85x11_Wall_Calendars': {
    primaryKeys: ['starting_month_v1', 'starting_month'],
    secondaryKeys: ['starting_year_v1', 'starting_year'],
    tertiaryKeys: '',
  },
  Keepsake_Calendar: {
    primaryKeys: ['starting_month_v1', 'starting_month'],
    secondaryKeys: ['starting_year_v1', 'starting_year'],
    tertiaryKeys: '',
  },
  canvas_EU: {
    primaryKeys: ['size_wa_v1', 'size_wa'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  posters_EU: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
  print_EU: {
    primaryKeys: ['size_pp_v1', 'size_pp'],
    secondaryKeys: '',
    tertiaryKeys: '',
  },
};

export const nonProductAttributeVariants = ['starting_month', 'starting_year'];

export const AttributeMapper = (variant: Variant, productType: string, attributesToBeConsidered?: string[]) => {
  const { primaryKeys, secondaryKeys, tertiaryKeys } = productTypeAttributeMap[productType] || {};

  const variantAttributes = JSON.parse(JSON.stringify(variant?.attributes ?? {}));

  // Add in any non-product=attribute variants. They are options that we want to show up on the PDP, but are not 
  // attributes on the product. So we add them here for the logic below to work so they will show up
  nonProductAttributeVariants.forEach((nonProductAttribute) => {
    variantAttributes[nonProductAttribute] = 'FAKE VALUE'
  });

  // Normalize keys into arrays (handles string, null, array)
  const normalizeKeys = (keys: unknown): string[] => {
    if (!keys) return [];
    if (Array.isArray(keys)) return keys.map(String);
    if (typeof keys === 'object' || typeof keys === 'symbol') return [];
    return [String(keys as string | number | boolean)];
  };

  const getAttributeLookupOrder = (key: string): string[] => {
    const normalizedKey = key.replace(/_v1$/, '');
    return Array.from(new Set([`${normalizedKey}_v1`, normalizedKey].filter(Boolean)));
  };

  const findMatchingKey = (keys: string[]): string => {
    const lookupKeys = keys.flatMap(getAttributeLookupOrder);

    if (!attributesToBeConsidered || attributesToBeConsidered.length === 0) {
      return lookupKeys.find((key) => key in variantAttributes) ?? '';
    }

    const allowedKeys = new Set(
      attributesToBeConsidered.flatMap((attribute) => getAttributeLookupOrder(attribute)),
    );

    return lookupKeys.find((key) => key in variantAttributes && allowedKeys.has(key)) ?? '';
  };

  return {
    primaryAttribute: findMatchingKey(normalizeKeys(primaryKeys)),
    secondaryAttribute: findMatchingKey(normalizeKeys(secondaryKeys)),
    tertiaryAttribute: findMatchingKey(normalizeKeys(tertiaryKeys)),
  };
};

export const isBooleanVariant = (currentVariantSelection: Record<string, string | number | boolean>, level: string) => {
  return typeof currentVariantSelection[level] === 'boolean';
};
export const isColorVariant = (attributes: Record<string, any>, level: string) => {
  return attributes[level].includes('color');
};

export const packSizeVariant = ['pack_size_cards', 'pack_size_cm'];
export const tierPriceVariant: string[] = [];
export const dropDownStartingMonthVariant = ['starting_month'];
export const dropDownStartingYearVariant = ['starting_year'];
